import { useLocalStorage } from '@vueuse/core'
import { NEW_VIDEOS_IN_PROCESS_KEY } from '@/constants'
import { ProcessingVideo, ProcessingVideoStatus } from '@/services/videos/types'

export function useProcessingVideosStorage(storageKey = NEW_VIDEOS_IN_PROCESS_KEY) {
  const videos = useLocalStorage<ProcessingVideo[]>(storageKey, [])

  const clearUserVideos = (userId: number | undefined) => {
    if (userId) {
      videos.value = videos.value.filter(v => v.userId !== userId)
    }
  }

  const getVideosForUser = (userId: number): ProcessingVideo[] => {
    return videos.value.filter(v => v.userId === userId)
  }

  const getFailedVideosForUser = (userId: number): ProcessingVideo[] => {
    return videos.value.filter(v => v.status === ProcessingVideoStatus.Failed && v.userId === userId)
  }

  const findVideoById = (videoId: string): ProcessingVideo | undefined => {
    return videos.value.find(v => v.video_id === videoId)
  }

  const removeVideoById = (videoId: string) => {
    videos.value = videos.value.filter(v => v.video_id !== videoId)
  }

  const addVideos = (newVideos: ProcessingVideo[]) => {
    videos.value = [...videos.value, ...newVideos]
  }

  const setVideos = (newVideos: ProcessingVideo[]) => {
    videos.value = newVideos
  }

  return {
    videos,
    clearUserVideos,
    getVideosForUser,
    getFailedVideosForUser,
    findVideoById,
    removeVideoById,
    addVideos,
    setVideos
  }
}
